import React from "react";
import Searchbar from "./components/Searchbar";
import MusicLoader from "./components/MusicLoader";

const playlist = ({
  icon,
  title,
  platforms,
  withSearch,
  searchPlaceholder,
  children,
  activity_type,
  selectedPlatform,
  showMilestones,
  isLoading,
  isLoadingMore = false,
  hasMore = false,
  onLoadMore = null,
  onPlatformsChange = () => { },
  height = "h-[55vh]",
}) => {
  console.log('load', isLoadingMore)
  return (
    <div className={`performance-section overflow-hidden bg-theme_clr1 rounded-xl mb-5 p-4 lg:px-5 pt-[26px] pb-[70px] ${height}`}>
        <div className="header-section flex flex-wrap items-center justify-between gap-2 mb-[10px] md:mb-[21px]">
          <div className="flex flex-wrap gap-6">
            <div className="flex items-center">
              <img
                src={icon}
                alt="icon-header"
                className="inline w-[22px] h-[22px] mr-2"
              />
              <span className="text-white text-[23px] font-bold font-manrope leading-tight">
                {title}
              </span>
            </div>
            {platforms?.length > 0 && (
              <div className="icons flex items-center gap-6">
                {platforms.map((platform) => (
                  <img
                    key={platform.alt}
                    src={platform.icon}
                    alt={platform.alt}
                    onClick={() => onPlatformsChange(platform.name)}
                    className={`block w-[30px] h-[30px] cursor-pointer ${selectedPlatform === platform.name
                        ? "ring-4 ring-orange-500 squared-full rounded"
                        : ""
                      }`}
                  />
                ))}
              </div>
            )}
          </div>
          {withSearch && (
            <Searchbar
              searchPlaceholder={searchPlaceholder}
              trackType={"track"}
              fetchTrackActivities
              sendingThrough={activity_type}
              type={activity_type}
              source={selectedPlatform}
            />
          )}
        </div> 

      {isLoading ? (
        <MusicLoader />) : (
        <div
          className="overflow-auto h-[calc(100%)] md:h-[calc(100%-40px)]"
          onScroll={(e) => {
            const target = e.target;
            const isBottom = target.scrollHeight - target.scrollTop - target.clientHeight < 60;
            if (isBottom && hasMore && !isLoadingMore && typeof onLoadMore === 'function') {
              onLoadMore();
            }
          }}
        >
          {children}
          {isLoadingMore && (
            <div className="w-full flex items-center justify-center py-4">
              <MusicLoader small />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default playlist;
